export default __webpack_public_path__ + "e70676253cbfa6761afe6337f4194cbc.png";